import React, { useState, useEffect } from 'react'
import LoginScreen from './pages/Login/LoginScreen'
import Notes from './pages/Notes/Notes'
import User from './User'
import * as firebase from './helpers/firebase'
import * as permStorage from './helpers/permanent-storage'
import 'bootstrap/dist/css/bootstrap.css'
import './App.scss'


function App() {
    const [user, setUser] = useState(User(permStorage.getUser()) || undefined)
    
    useEffect(() => {
        if (user && user.isLoggedIn) {
            // setup the logout listener
            const unsubscribe = firebase.onAuthStateChanged(function onLogout(authResult) {
                if (!authResult) {
                    // User logged out or they were actually logged out to begin with
                    // even though we had them in storage as being logged in.
                    const newUser = User({...user, isLoggedIn: false})
                    permStorage.setUser(newUser)
                    setUser(newUser)
                }
            })

            return unsubscribe
        }
        else if (user === undefined) {
            // We don't have record of this user in localStorage, we need to check with Firebase
            waitForFirebaseAuthInit()
                .then(authResult => {
                    if (authResult) {
                        // User is logged in
                        const loggedInUser = User(authResult)
                        permStorage.setUser(loggedInUser)
                        setUser(loggedInUser)
                    } else {
                        // We don't have a user
                        setUser(null)
                    }
                })
                .catch(e => console.log('Could not verify user via Firebase Auth:', e))
        } 
    }, [user])

    // This function just sets up an authStateChangedListener and then immediately
    // unsubscribes from it once it resolves. We can use it to wait until Firebase is ready
    // before proceding to check details about the user.
    function waitForFirebaseAuthInit() {
        return new Promise((resolve, reject) => {
            const unsubscribe = firebase.onAuthStateChanged(authResult => {
                unsubscribe()
                resolve(authResult)
            }, reject)
        })
    }

    function handleUserLogin(userData) {
        const user = User({ ...userData, isLoggedIn: true })
        permStorage.setUser(user)
        setUser(user)
    }


    if (user) {
        if (user.isLoggedIn) {
            return <Notes user={user}></Notes>
        } else {
            return <LoginScreen lastLoggedInUser={user} onUserLoggedIn={handleUserLogin} />
        }
    }
    
    if (user === undefined) {
        return null
    } else {
        return <LoginScreen lastLoggedInUser={null} onUserLoggedIn={handleUserLogin} />    
    }
}

export default App
